export enum PublicInclusionStatus {
    NOT_APPLIED,
    APPLIED,
    PENDING_CHANGES
}